var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diamond"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.43431 14.4344C3.64228 13.6424 3.24626 13.2463 3.09789 12.7897C2.96737 12.388 2.96737 11.9553 3.09789 11.5536C3.24626 11.097 3.64228 10.7009 4.43431 9.9089L9.9089 4.43431C10.7009 3.64228 11.097 3.24626 11.5536 3.09789C11.9553 2.96737 12.388 2.96737 12.7897 3.09789C13.2463 3.24626 13.6424 3.64228 14.4344 4.43431L19.909 9.9089C20.701 10.7009 21.097 11.097 21.2454 11.5536C21.3759 11.9553 21.3759 12.388 21.2454 12.7897C21.097 13.2463 20.701 13.6424 19.909 14.4344L14.4344 19.909C13.6424 20.701 13.2463 21.097 12.7897 21.2454C12.388 21.3759 11.9553 21.3759 11.5536 21.2454C11.097 21.097 10.7009 20.701 9.9089 19.909L4.43431 14.4344Z",
    fill: "#2F80ED",
    stroke: "#2F80ED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M10.3128 12.4934C10.1401 12.3207 10.0537 12.2344 10.0213 12.1348C9.99288 12.0472 9.99288 11.9528 10.0213 11.8652C10.0537 11.7656 10.1401 11.6793 10.3128 11.5066L11.5066 10.3128C11.6793 10.1401 11.7656 10.0537 11.8652 10.0213C11.9528 9.99288 12.0472 9.99288 12.1348 10.0213C12.2344 10.0537 12.3207 10.1401 12.4934 10.3128L13.6872 11.5066C13.8599 11.6793 13.9463 11.7656 13.9787 11.8652C14.0071 11.9528 14.0071 12.0472 13.9787 12.1348C13.9463 12.2344 13.8599 12.3207 13.6872 12.4934L12.4934 13.6872C12.3207 13.8599 12.2344 13.9463 12.1348 13.9787C12.0472 14.0071 11.9528 14.0071 11.8652 13.9787C11.7656 13.9463 11.6793 13.8599 11.5066 13.6872L10.3128 12.4934Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintIcon);
export default __webpack_public_path__ + "static/media/mintIcon.7fce246c6bff0100ad3999910efd4fcb.svg";
export { ForwardRef as ReactComponent };